<template>

    <div class="absolute w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
        <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 22.5rem;">

            <span class="border-b border-theme-discrete"><p class="text-lg text-theme-title font-bold mb-2">{{ translate('playlist-add') }} - {{ translate('playlist-choose') }}</p></span>

            <select name="playlistSelect" id="playListSelect" v-model="selectedPlaylistId" class="form-select bg-theme-level4 mb-4 mt-4 text-theme-main">
                <option v-for="item in playlists" :value="{ id: item.id, name: item.name }">{{ item.name }}</option>
            </select>

            <div class="mb-12">

                <button class="text-base bg-theme-controls1 text-theme-control-label rounded-lg px-4 h-10 cursor-default" :disabled="!selectedPlaylistId" :class="{ 'hover:bg-theme-controls3': selectedPlaylistId, 'cursor-pointer': selectedPlaylistId }" @click="assignPlaylist">
                    <span :class="{ 'text-theme-muted': !selectedPlaylistId }">{{ translate('playlists-assign') }}</span>
                </button>

                <button class="text-base bg-theme-controls1 hover:bg-theme-controls3 text-theme-control-label rounded-lg px-4 w-32 h-10" @click="dismissPlaylistsChooser">
                    {{ translate('cancel') }}
                </button>

            </div>


            <p class="text-theme-main text-base">{{ translate('playlist-create-new') }}</p>

            <div class="py-2">
                <input v-model="newPlaylistName" type="text" :placeholder="translate('playlist-enter-new')" class="appearance-none bg-theme-level4 border-none w-full text-theme-main mr-3 py-2 px-2 focus:outline-none rounded-md" />
            </div>

            <div class="mb-8">

                <button class="text-base bg-theme-controls1 text-theme-control-label rounded-lg px-4 h-10 cursor-default" :disabled="!newPlaylistName" :class="{ 'hover:bg-theme-controls3': newPlaylistName, 'cursor-pointer': newPlaylistName }" @click="createAndAssignPlaylist">
                    <span :class="{ 'text-theme-muted': !newPlaylistName }">{{ translate('playlist-create-assign') }}</span>
                </button>

            </div>

        </div>
    </div>

</template>

<script>

    import vSelect from 'vue-select';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            vSelect
        },

        props: [

            'currentlocale',
            'user_id'

        ],

        data() {

            return {

                playlists: '',
                selectedPlaylistId: this.$root.shared.preselectedPlaylist,
                newPlaylistName: ''

            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            dismissPlaylistsChooser() {
                this.$root.shared.playlistChooserVisible = false
            },

            assignPlaylist() {

                axios.get('/' + this.currentlocale + '/playlists/add/' + this.selectedPlaylistId.id + '/' + this.$root.shared.contentIdToAddToPlaylist)
                    .then((response) => {

                        /*console.log(this.selectedPlaylistId)*/

                        this.$root.shared.playlistChooserVisible = false
                        this.flashMessage.success({
                            title: '',
                            message: this.translate('playlist-added') + ' ' + this.selectedPlaylistId.name,
                            blockClass: 'p-6',
                            x: 25,
                            y: 150,
                            time: 3000
                        });
                    })
                    .catch((error) => {
                        console.log('ERROR trying to assign Content to Playlist: ' + error)
                    })

            },

            createAndAssignPlaylist() {

                // First, create the Playlist and "select it"
                axios.get('/' + this.currentlocale + '/playlists/create/' + this.user_id + '/' + this.newPlaylistName)
                    .then((response) => {

                        let newPlaylist = response.data

                        this.playlists.push(newPlaylist)
                        this.newPlaylistName = null

                        // Since we successfully created the new playlist,
                        // we can assign the content to it

                        axios.get('/' + this.currentlocale + '/playlists/add/' + newPlaylist.id + '/' + this.$root.shared.contentIdToAddToPlaylist)
                            .then((response) => {

                                this.$root.shared.playlistChooserVisible = false
                                this.flashMessage.success({
                                    title: '',
                                    message: this.translate('playlist-added') + ' ' + newPlaylist.name,
                                    blockClass: 'p-6',
                                    x: 25,
                                    y: 150,
                                    time: 3000
                                });
                            })
                            .catch((error) => {
                                console.log('ERROR trying to assign Content to Playlist: ' + error)
                            })
                    })
                    .catch((error) => {
                        console.log('ERROR trying to Create New Playlist ' + this.newPlaylistName + ': ' + error)
                    })
            }

        },

        created() {

            axios.get('/' + this.currentlocale + '/playlists/' + this.user_id)
                .then((response) => {
                    if(response.data) {
                        this.playlists = response.data.map(item => { return { id: item.id, name: item.name } })
                        this.$root.shared.preselectedPlaylist = this.playlists[0]
                        this.selectedPlaylistId = this.playlists[0]
                    }
                })
                .catch((error) => {
                    console.log('ERROR trying to get User ID ' + this.user_id + ' Playlists: ' + error)
                })

        }

    }

</script>
